export const ProjectTypeChoices = (value) => {
  switch (value) {
    case 0:
      return 'Solar Only';
    case 1:
      return 'Solar + Upgrades';
    case 2:
      return 'Solar + ESS';
    default:
      return 'N/A';
  }
};

export const RoofComplexityChoices = (value) => {
  switch (value) {
    case 0:
      return 'Ideal';
    case 1:
      return 'Semi-Ideal';
    case 2:
      return 'Typical';
    case 3:
      return 'Difficult';
    default:
      return 'N/A';
  }
};

export const OwnerTypeChoices = (value) => {
  switch (value) {
    case 0:
      return 'Non-Owner Tenant';
    case 1:
      return 'Property Owner / Owner-User / Partner';
    case 2:
      return 'Employee / Representative of Owner';
    default:
      return 'N/A';
  }
};

export const BuildingTypeChoices = (value) => {
  switch (value) {
    case 1:
      return 'Warehouse';
    case 2:
      return 'Distribution Center';
    case 3:
      return 'Heavy Manufacturing';
    case 4:
      return 'Retail / Shopping Center';
    case 5:
      return 'School';
    case 6:
      return 'Multi-Family Residential';
    case 7:
      return 'Cold Storage';
    case 8:
      return 'Light Manufacturing';
    case 9:
      return 'Grocery Store';
    case 10:
      return 'Church';
    case 11:
      return 'Commercial Office';
    case 12:
      return 'Resort / Hotel';
    case 13:
      return 'Other / Not Listed';
    case 14:
      return 'General Class A Office';
    case 15:
      return 'Medical Office';
    case 16:
      return 'Community Center';
    case 17:
      return 'Class C Office';
    case 18:
      return 'Sports Complexes / Gyms';
    case 19:
      return 'Parking Garages';
    case 20:
      return 'Hospitals or Nursing Facilities';
    case 21:
      return 'Not-for-profits / Civic Properties';
    case 22:
      return 'Data Center';
    case 23:
      return 'Marinas or County Club';
    case 24:
      return 'Auto Dealerships / Autobody Repair';
    case 25:
      return 'Orchard';
    default:
      return 'N/A';
  }
};

export const LeadStatusChoices = (value) => {
  switch (value) {
    case 0:
      return 'Lead created';
    case 1:
      return 'Marketing proposal';
    case 2:
      return 'Utility data';
    case 3:
      return 'Preliminary proposal';
    case 4:
      return 'Site survey';
    case 5:
      return 'Detailed proposal';
    case 6:
      return 'Sale completed';
    default:
      return null;
  }
};

export const AdditionalFilesTypesChoices = (value) => {
  switch (value) {
    case 0:
      return 'Other Files';
    case 1:
      return 'Roof Layout File';
    case 2:
      return 'Direct Access Contract';
    case 3:
      return 'Energy Toolbase';
    case 4:
      return 'Helioscope';
    case 5:
      return 'PV Syst';
    case 6:
      return 'Site Survey';
    case 7:
      return '15-minute interval data';
    case 8:
      return 'Roof Warranty';
    case 9:
      return 'Other PV design report';
    default:
      return null;
  }
};

export const InstallTypesChoices = (value) => {
  switch (value) {
    case 0:
      return 'Rooftop';
    case 1:
      return 'Ground Mount';
    case 2:
      return 'Carport';
    case 3:
      return 'Multiple';
    default:
      return 'Rooftop';
  }
};

export const SurveyStatusChoices = (value) => {
  switch (value) {
    case 0:
      return 'Not Scheduled';
    case 1:
      return 'Scheduled';
    case 2:
      return 'Complete';
    default:
      return 'N/A';
  }
};

export const AgreementTypeChoices = (value) => {
  switch (value) {
    case 0:
      return 'LOI';
    case 1:
      return 'Clean Energy PPA';
    default:
      return 'N/A';
  }
};

export const DispositionChoices = (value) => {
  switch (value) {
    case 0:
      return 'Space Constraints';
    case 1:
      return 'PACE Ineligible';
    case 2:
      return 'Inactive Territory';
    case 3:
      return 'Outside Scope';
    case 4:
      return 'No Savings';
    case 5:
      return 'No Longer Interested';
    case 6:
      return 'Unable to Contact';
    default:
      return 'N/A';
  }
};

export const SDRFinanceStatusChoices = (value) => {
  switch (value) {
    case 0:
      return 'Eligible';
    case 1:
      return 'Pending';
    case 2:
      return 'Not Eligible';
    default:
      return 'N/A';
  }
};

export const surveyStatuses = [
  {
    value: 0,
    title: 'Not Scheduled',
  },
  {
    value: 1,
    title: 'Scheduled',
  },
  {
    value: 2,
    title: 'Complete',
  },
];

export const dispositions = [
  {
    value: 0,
    title: 'Space Constraints',
  },
  {
    value: 1,
    title: 'PACE Ineligible',
  },
  {
    value: 2,
    title: 'Inactive Territory',
  },
  {
    value: 3,
    title: 'Outside Scope',
  },
  {
    value: 4,
    title: 'No Savings',
  },
  {
    value: 5,
    title: 'No Longer Interested',
  },
  {
    value: 6,
    title: 'Unable to Contact',
  },
];

export const SDRFinanceStatuses = [
  {
    value: 0,
    title: 'Eligible',
  },
  {
    value: 1,
    title: 'Pending',
  },
  {
    value: 2,
    title: 'Not Eligible',
  },
];

export const QuoteTypeChoices = (value) => {
  switch (value) {
    case 0:
      return 'PPA';
    case 1:
      return 'PACE Financing';
  }
};

export const OwnerTypesChoices = (value) => {
  switch (value) {
    case 0:
      return 'Non-Owner Tenant';
    case 1:
      return 'Property Owner / Owner-User / Partner';
    case 2:
      return 'Employee / Representative of Owner';
  }
};
